import type { ViewComponent } from "@frui.ts/views";
import type SubLedgerNewReportViewModel from "../../../../viewModels/finance/subLedger/SubLedgerNewReportViewModel";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import React from "react";
import { Input } from "@frui.ts/bootstrap";
import DateRangeInputControl from "../../../../controls/dateRangeInput";
import FormGroup from "../../../../controls/formGroup";
import CountrySelect from "../../../common/countrySelect";
import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";
import FormLabel from "../../../../controls/formLabel";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";

export const OrderParameters: ViewComponent<SubLedgerNewReportViewModel> = observer(({ vm }) => {
  return (
    <div style={{ paddingBottom: "2.5rem" }}>
      <h5>{vm.translate("orderParameters.name")}</h5>

      <div className="row">
        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("orderParameters.orderId")}*</Form.Label>
          <Input
            target={vm.order}
            property="id"
            placeholder={vm.translate("orderParameters.orderId")}
            disabled={!vm.canEditOrder}
          />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("orderParameters.variableSymbol")}*</Form.Label>
          <Input
            target={vm.order}
            property="orderIdent"
            placeholder={vm.translate("orderParameters.variableSymbol")}
            disabled={!vm.canEditOrder}
            type="number"
          />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>
            {vm.translate("orderParameters.createdDate")}
            {(vm.order.kioskId || vm.order.salespointId) && <span>*</span>}
          </Form.Label>
          <DateRangeInputControl
            target={vm.order}
            property="createdDate"
            disabled={!vm.canEditOrder}
            onValueChanged={() => vm.validateDateRange(vm.order, "createdDate")}
          />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("orderParameters.email")}*</Form.Label>
          <Input
            target={vm.order}
            property="email"
            placeholder={vm.translate("orderParameters.email")}
            disabled={!vm.canEditOrder}
          />
        </Form.Group>
      </div>

      <div className="row">
        <Form.Group as={Col} lg={6} xl={6}>
          <FormLabel>
            {vm.translate("orderParameters.salespoint")}
            <span style={{ fontSize: 12, fontWeight: "normal", paddingLeft: "0.4rem" }}>
              {vm.translate("orderParameters.combineWithDate")}
            </span>
          </FormLabel>
          <AdvancedSelect
            allowEmpty={true}
            target={vm.order}
            property="salespointId"
            items={vm.salespoints}
            onInputChange={vm.onSalesPointSearch}
            placeholder={vm.translate("orderParameters.salespoint")}
            disabled={!vm.canEditOrder || !!vm.order.kioskId}
          />
        </Form.Group>

        <Form.Group as={Col} lg={6} xl={6}>
          <FormLabel>{vm.translate("orderParameters.kiosk")}</FormLabel>
          <span style={{ fontSize: 12, fontWeight: "normal", paddingLeft: "0.4rem" }}>
            {vm.translate("orderParameters.combineWithDate")}
          </span>
          <AdvancedSelect
            allowEmpty={true}
            target={vm.order}
            property="kioskId"
            items={vm.kiosks}
            placeholder={vm.translate("orderParameters.kiosk")}
            disabled={!vm.canEditOrder || !!vm.order.salespointId}
          />
        </Form.Group>
      </div>

      <div className="row">
        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("chargeParameters.chargeId")}*</Form.Label>
          <Input
            target={vm.order}
            property="chargeId"
            placeholder={vm.translate("chargeParameters.chargeId")}
            disabled={!vm.canEditOrder}
          />
        </Form.Group>

        <FormGroup as={Col} md={6} className="col-xxl-4" target={vm.order} property="countryId">
          <Form.Label>{vm.translateAttribute("licensePlate.countryId")}</Form.Label>
          <CountrySelect
            allowEmpty
            vm={vm.countrySelectViewModel}
            placeholder={vm.translateAttribute("licensePlate.countryId")}
            disabled={!vm.canEditOrder}
          />
        </FormGroup>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translateAttribute("licensePlate.licensePlate")}*</Form.Label>
          <AdvancedInput
            target={vm.order}
            property="licensePlate"
            placeholder={vm.translateAttribute("licensePlate.licensePlate")}
            transformation={Transformation.UpperCased}
            disabled={!vm.canEditOrder}
          />
        </Form.Group>
      </div>
    </div>
  );
});
